import BaseCardBehavior from './BaseCardBehavior';
import { ICardsState } from '../ICardState';
import CardStateHelper from '../CardStateHelper';
import { BoosterType } from '../BoosterType';
import { CardTask } from '../CardTasks';
import { IGameState } from 'State/Game/IGameState';
import { CardState } from 'Prototype/Level/Card/CardState';

export default class CanisterPreBoosterCardBehavior extends BaseCardBehavior {
    public isPlayable(state: ICardsState) {
        return this.cardID === state.inStack[state.inStack.length - 1];
    }

    public play(state: IGameState): IGameState {
        let cardsState: ICardsState = { ...state.levelState.cardsState };
        const currentCardState = CardStateHelper.getCardState(cardsState, this.cardID);
        if (currentCardState === CardState.IN_STACK) {
            state = CardStateHelper.foldStackCard(state, this.cardID, { skipAnimation: true });
        }

        state = CardStateHelper.playBooster(state, BoosterType.TNT, {
            ignoreCost: true,
            flipCard: this.cardID,
            force: true,
        });

        cardsState = CardStateHelper.getCardsState(state);

        cardsState = CardStateHelper.setCardDiscarded(cardsState, this.cardID);

        cardsState = CardStateHelper.checkCardsObscured(cardsState);

        cardsState = CardStateHelper.setStateTaskData(cardsState, {
            task: CardTask.USE_CANISTER_PRE_BOOSTER,
            cards: [this.cardID],
        });

        // Update all cards behavior after some of them are discarded.
        cardsState = CardStateHelper.updateCards(cardsState);
        cardsState = CardStateHelper.clearUndoHistory(cardsState);

        return CardStateHelper.updateGameState(state, cardsState);
    }
}
